export default __webpack_public_path__ + "static/media/9_16-story-web.8fd73b7f.png";